import { SendWelcomeEmailRequest } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const sendWelcomeEmail = (
  req: Partial<SendWelcomeEmailRequest>
): Promise<void> =>
  request({
    url: '/service/userv2service/SendWelcomeEmail',
    body: req,
  }).then((r) => r.body);
